import { FC } from 'react';
import { Outlet, ReactLocation, Router } from '@tanstack/react-location';
import { useRoutes } from '../providers/routes.provider';

interface IMain {
  location: ReactLocation;
}

export const Main: FC<React.PropsWithChildren<IMain>> = ({ location }) => {
  const { routes } = useRoutes();

  return (
    <Router routes={routes} location={location} useErrorBoundary={false}>
      <Outlet />
    </Router>
  );
};
